// extracted by mini-css-extract-plugin
export default {"technicalAspectsContainer":"technicalAspectsFilters_technicalAspectsContainer__BqemZ","collapsableComponent":"technicalAspectsFilters_collapsableComponent__R9ryp"};